<div class="admin-page-container">

  <admin-toolbar class="admin-toolbar" (toggleSidebar)="toggleSidebar()" section="Pending Users"></admin-toolbar>

  <mat-sidenav-container id="admin-content-wrapper" class="admin-content-wrapper">

    <mat-sidenav #adminsidenav class="admin-sidebar">

      <admin-sidebar></admin-sidebar>

    </mat-sidenav>

    <mat-sidenav-content>

      <!-- [START] page content -->

      <mat-card style="width: 100%; display: block;">

        <mat-card-header>
          <mat-card-title>Pending Users</mat-card-title>
        </mat-card-header>

        <mat-card-content style="padding-left: 16px;">

          <p>To Approve a user click on their userid or the approve action.</p>

          <p-table  selectionMode="single"  dataKey="userid"  [value]="userList">

            <ng-template pTemplate="header">
              <tr style="background-color: #2D323D;">
                <th width="80">ID</th>
                <th>userid</th>
                <th>Name</th>
                <th>eMail</th>
                <th>Actions</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-user>

              <tr [className]="'userListrowWrapper'" >

                <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">{{user.id}}</td>

                <td *ngIf="user.is_pending" style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;"><a style="color: white; text-decoration: none; text-underline: none; font-weight: bold;" [routerLink]="['/administration/users/approve/', user.userid]">{{user.userid}}</a></td>

                <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">{{user.display_name}}</td>
                <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">{{user.email}}</td>

                <td style="font-size: 10px;">

                  <!-- pending users must be approved before you can do anything with them -->

                  <a *ngIf="user.is_pending" class="useractionicon" [routerLink]="['/administration/users/approve/', user.userid]">
                    <img width="16" src="assets/images/check-64.png">
                  </a>

                </td>
              </tr>
            </ng-template>
          </p-table>

        </mat-card-content>
      </mat-card>

      <!-- [END] page content -->

      <admin-footer section="Pending Users"></admin-footer>

    </mat-sidenav-content>

  </mat-sidenav-container>

</div>

